import React from 'react';
import { AlertCircle, AlertTriangle, Info } from 'lucide-react';

const icons = { info: Info, attention: AlertTriangle, danger: AlertCircle };

// One calm status block per condition: icon, a short title that names the
// situation, one sentence on what happens next, and the action if there is one.
export function BillingStatus({ tone = 'info', title, text, children }) {
    const Icon = icons[tone] || Info;
    const actions = React.Children.toArray(children);
    return <div className={`billing-status billing-status--${tone}`} role={tone === 'danger' ? 'alert' : 'status'}>
        <span className="billing-status-icon" aria-hidden="true"><Icon size={16} /></span>
        <div className="billing-status-body">
            {title && <p className="billing-status-title">{title}</p>}
            {text && <p className="billing-status-text">{text}</p>}
            {actions.length > 0 && <div className="billing-status-actions">{actions}</div>}
        </div>
    </div>;
}

// Label / value / action rows, the settings pattern used for billing pages:
// the fact on the left, its explanation under it, the single action on the right.
export function BillingRow({ label, value, hint, actions }) {
    return <div className="billing-row">
        <dt className="billing-row-label">{label}</dt>
        <dd>
            <div className="billing-row-value">
                <span className="billing-row-primary">{value}</span>
                {hint && <span className="billing-row-hint">{hint}</span>}
            </div>
            {actions && <div className="billing-row-actions">{actions}</div>}
        </dd>
    </div>;
}
